export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const monthFull = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
export const date = new Date();
export const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).toISOString();
export const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString();

export const isURL = (data: string) => {
    const httpRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
    return {
        __html: httpRegex.test(data)
            ? `<a href="${data}">${data}</a>`
            : data
    };
}

export const isImage = (data: any) => {
    let src = "";
    if("attachments" in data) {
        data.attachments.map((item: any) => {
            if(item.mimeType.indexOf('image')>-1) {
                src = `https://drive.google.com/uc?id=${item.fileId}`;
            }
        });
    }
    return src;
}

export const getEventData = (FilterData: any, API_KEY: any, CALENDAR_ID: any, setEventData: any) => {

    setEventData([]);

    const point = "https://www.googleapis.com/calendar/v3/calendars/"+CALENDAR_ID+ "/events?";
    const urlQuery = [
        `key=${API_KEY}`,
        `timeMax=${FilterData[1]}`,
        `timeMin=${FilterData[0]}`,
        `singleEvents=true`,
        `orderBy=startTime`
    ];

    fetch( point+urlQuery.join('&'), {method: 'GET'})
    .then((response) => response.json())
    .then((data) => {
        setEventData(data.items);
    })
    .catch((error) => {
        console.error('Error:', error);
    });

}

export const getFirstLastDay = (date: Date, index: number) => {

    const firstDay = new Date(date.getFullYear(), index, 1).toISOString();
    const lastDay = new Date(date.getFullYear(), index + 1, 0).toISOString();

    return [firstDay, lastDay];
}

export const getEventDate = (item: any) => {

    if( item.start && item.start.dateTime) {
        return {date: item.start.dateTime, time: true};
    }
    else if (item.originalStartTime) {
        return {date: item.originalStartTime.dateTime, time: true};
    } else {
        return {date: item.start.date, time: false};
    }

}